import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = () => {
  const currentYear = new Date().getFullYear(); // Hämta innevarande år

  return (
    <Box
      component="footer"
      sx={{
        padding: "20px",
        backgroundColor: "#f5f5f5",
        textAlign: "center",
        marginTop: "auto",
      }}
    >
      <Typography variant="body2" color="textSecondary">
        &copy; {currentYear} Kintab. All rights reserved.
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        sx={{ marginTop: "8px" }}
      >
        Created by ONIT
      </Typography>
    </Box>
  );
};

export default Footer;
